import Joi from "joi";
import date from "@joi/date";
import {createTheme} from "@mui/material/styles";
import dayjs from "dayjs";
import {PositionProps} from "../../../../utils/types";

const joi = Joi.extend(date);

export const schema = joi
    .object({
        jobTitle: joi.string().label('Job Title').required(),
        companyName: joi.string().label('Company Name').required(),
        city: joi.string().label('City').required(),
        employmentType: joi.string().label('Employment Type').required(),
        current: joi.boolean().label('I am currently working in this role').required(),
        fromDate: joi.any().custom((value: dayjs.Dayjs, helper: any) => value ? value : helper.message('Invalid date')).label('From'),
        toDate: joi.any().custom((value: dayjs.Dayjs, helper: any) => value ? value : helper.message('Invalid date'))
            .custom((value: dayjs.Dayjs, helper: any) => {
            const { fromDate } = helper.state.ancestors[0]
            return value.diff(fromDate) > 0 ? value : helper.message('Should be greater than From')
        })
    })
    .required()

export interface AddPositionProps {
    country: 0 | 1,
    onAdd: (data: PositionProps) => void,
    isOpen: boolean,
    onClose: () => void
    position: PositionProps | null
}

export const newTheme = (theme: any) => createTheme({
    ...theme,
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    borderRadius: '0.5rem',
                }
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '0.5rem',
                }
            }
        },
        MuiDateCalendar: {
            styleOverrides: {
                root: {
                    color: '#FB7672',
                    borderRadius: '2px',
                    borderWidth: '1px',
                    borderColor: '#FB7672',
                    border: '1px solid',
                }
            }
        },
        MuiModal: {
            styleOverrides: {
                root: {
                    zIndex: 13000
                }
            }
        },
        MuiPickersPopper: {
            styleOverrides: {
                root: {
                    zIndex: 13000
                }
            }

        },
        MuiButton: {
            styleOverrides: {
                text: {
                    color: '#FB7672',
                }
            }
        },
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    borderColor: '#FB7672',
                },
                today: {
                    color: '#FB7672',
                    borderColor: '#FB7672',
                },
            }
        }
    },
    palette: {
        primary: {
            light: '#757ce8',
            main: '#0B4598',
            dark: '#0B4598',
            contrastText: '#fff',
        },
        secondary: {
            light: '#13CA82',
            main: '#FB7672',
            dark: '#D32F2F',
            contrastText: '#000',
        },
    },
})